let $swiper = document.querySelectorAll('.js-swiper');

$swiper.forEach((elem, i) => {
  let swiper = new Swiper(elem, {
      speed: 600,
      effect: 'fade',
      navigation: false,
      fadeEffect: {
          crossFade: false
      },
      slidesPerView: 1,
      loop: true,
      allowTouchMove: true,
      pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true,
      }
  });
});
